// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row {
  display: flex;
  font-size: 0.85rem;
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/info-suddivisione/info-suddivisione.page.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EAEA,kBAAA;EACA,eAAA;AAAF","sourcesContent":[".row {\n  display: flex;\n  //justify-content: space-between;\n  font-size: 0.85rem;\n  margin-top: 4px;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
